let nurse = [
  {
    path: '/nurse',
    name: '护理平台',
    component: () => import('@/pages/nursePlatform/index')
  },
  {
    path: '/nurse_online_ask',
    name: '护理平台在线咨询',
    component: () => import('@/pages/nursePlatform/nurse_online_ask')
  },
  {
    path: '/nurse_online_broadcast',
    name: '护理平台在线直播',
    component: () => import('@/pages/nursePlatform/nurse_online_broadcast')
  },
  {
    path: '/nurse_area',
    name: '护理专区',
    component: () => import('@/pages/nursePlatform/nurse_area')
  },
  {
    path: '/nurse_hospital',
    name: '护理专区',
    component: () => import('@/pages/nursePlatform/nurse_hospital')
  },
  {
    path: '/nurse_hospital_detail',
    name: '护理专区',
    component: () => import('@/pages/nursePlatform/nurse_hospital_detail')
  },
  {
    path: '/nurse_team_style',
    name: '团队风采',
    component: () => import('@/pages/nursePlatform/nurse_team_style')
  }
]

export default nurse
/**
 * Created by Administrator on 2019/6/10.
 */
